<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <customer-form :model="customer"
                     :resource="resource"
                     :action="action"
                     :canUpdate="canUpdate"
                     :canDelete="canDelete"
                     @created="handleCreated"
                     @updated="handleUpdated"
                     @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import CustomerForm from './CustomerForm.vue';

export default {
  mixins: [modal, resource],

  components: { CustomerForm },

  computed: {
    customer() {
      return this.data;
    },
    resource() {
      return 'customers';
    },
  },

  methods: {
    handleCreated(customer) {
      Event.fire('customerCreated', customer);
    },
    handleUpdated(customer) {
      Event.fire('customerUpdated', customer);
    },
    handleDeleted(customer) {
      Event.fire('customerDeleted', customer);
    },
  },
};
</script>